// extracted by mini-css-extract-plugin
module.exports = {"title":"ExpandedTablePrintLayout_title__OjNtl"};